import { axiosWrapper } from "~/utils/errors/axiosWrapper";

import dadata from "./dadata";
import databaseContent from "./databaseContent";
import edost from "./edost";
import sdek from "./sdek";
import sections from "./sections";

/**
 * Серверный API — прямые запросы к внешним бэкендам (bxApi, nestFarkopDatabase).
 * Вызывается на серверной стороне: из pages/api/client/*\/*.ts (BFF-слой) и из
 * SSR-путей (например redux `fetchSections`). Всегда выполняется на сервере,
 * поэтому конфиг не ветвится по window и не зависит от общего api/index.ts —
 * свой независимый конфиг.
 */
const config = {
  API_URL: `${process.env.BITRIX_API_URL}/bxApi`,
  SERVICE_DATABASE_API_URL: `${process.env.SERVICE_DATABASE_API_URL}/database`,
};

export const ApiServer = {
  dadata: dadata(axiosWrapper, config),
  databaseContent: databaseContent(axiosWrapper, config),
  edost: edost(axiosWrapper, config),
  sdek: sdek(axiosWrapper, config),
  sections: sections(axiosWrapper, config),
};
